import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "../../../../styles/lead-mangement/lms-followups.css";
import LMSFollowupsStatCards from "../lms-v2-cards/LMSFollowupsStatCards";
import LMSTodaysFollowups from "../lms-logs-listings/LMSTodaysFollowups";
import LMSFollowupDetails from "../lms-v2-cards/LMSFollowupDetails";
import LeadFollowup from "../lead-journey/LeadFollowup";

const LMSFollowups = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  isMissed,
  userInfoData,
  setModValues,
}) => {
  const { allLeadsLoading } = useSelector((state) => state.api);

  const [selectedRow, setSelectedRow] = useState(null);

  if (allLeadsLoading) {
    return (
      <div className="lead-v2-cycle-loading">
        <div className="lead-v2-loading-spinner"></div>
        <p>Loading leads...</p>
      </div>
    );
  }

  return (
    <div className="followups-main-container">
      <div className="followups-header">
        <span
          className="followups-header-icon"
          role="img"
          aria-label="calendar"
        >
          📅
        </span>
        <span className="followups-header-title">
          Follow-ups Calendar & Schedule
        </span>
      </div>

      <div className="followups-content-flex">
        <LMSTodaysFollowups
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isMissed={isMissed}
          // setSelectedRow={isMissed ? setSelectedRow : null}
          // selectedRow={isMissed ? selectedRow : null}
          setSelectedRow={setSelectedRow || ""}
          selectedRow={selectedRow || ""}
          setModValues={setModValues}
        />

        {selectedRow ? (
          <div className="followup-details-container">
            <LeadFollowup
              userInfoData={userInfoData}
              rowData={selectedRow}
              isTable={true}
              closeModal={() => setSelectedRow(null)}
            />
          </div>
        ) : (
          <div className="lms-details-right-panel">
            <div className="lms-details-empty-state">
              No follow-up selected.
              <br />
              Please click on Reschedule button from the list to add follow-up.
            </div>
          </div>
        )}

        {/* {isMissed ? (
          <LMSFollowupDetails selectedRow={selectedRow} />
        ) : (
          <LMSFollowupsStatCards />
        )} */}
      </div>
    </div>
  );
};

export default LMSFollowups;
